module.exports = "/_next/static/images/game-2-menu-phone-a3ca696ffa839d78c68826d6995afd45.png";